<div class="rapports-page">

  <!-- ╔══════ En-tête ══════╗ -->
  <header class="rapports-header">
    <div class="rapports-header__titre">
      <h1><i class="fal fa-chart-bar"></i> Rapports &amp; indicateurs</h1>
      <p class="sous-titre">Pilotage opérationnel et financier — 18 indicateurs clés</p>
    </div>
    <div class="rapports-header__role">
      <span class="badge-role" [ngClass]="'role-' + roleUtilisateur.toLowerCase()">
        <i class="fal fa-shield-alt"></i> {{ roleUtilisateur }}
      </span>
    </div>
  </header>

  <!-- ╔══════ Barre de filtres communs ══════╗ -->
  <section class="filtres-bar">
    <div class="filtres-grille">
      <div class="filtre-item">
        <label>Du</label>
        <input type="date" [value]="dateDebutLocale()" (change)="surChangementDateDebut($any($event.target).value)" />
      </div>
      <div class="filtre-item">
        <label>Au</label>
        <input type="date" [value]="dateFinLocale()" (change)="surChangementDateFin($any($event.target).value)" />
      </div>
      <div class="filtre-item">
        <label>Type d'envoi</label>
        <select [ngModel]="filtres.typeEnvoi" (ngModelChange)="surChangementTypeEnvoi($event)">
          <option [ngValue]="null">Tous</option>
          <option *ngFor="let t of typesEnvoi" [value]="t.value">{{ t.label }}</option>
        </select>
      </div>
      <div class="filtre-item">
        <label>Granularité</label>
        <select [ngModel]="filtres.granularite" (ngModelChange)="surChangementGranularite($event)">
          <option value="JOUR">Jour</option>
          <option value="SEMAINE">Semaine</option>
          <option value="MOIS">Mois</option>
          <option value="TRIMESTRE">Trimestre</option>
          <option value="SEMESTRE">Semestre</option>
          <option value="ANNEE">Année</option>
        </select>
      </div>
    </div>

    <div class="filtres-presets">
      <button class="chip-preset" (click)="appliquerPresetPeriode(7)">7 j</button>
      <button class="chip-preset" (click)="appliquerPresetPeriode(30)">30 j</button>
      <button class="chip-preset" (click)="appliquerPresetPeriode(90)">3 mois</button>
      <button class="chip-preset" (click)="appliquerPresetPeriode(180)">6 mois</button>
      <button class="chip-preset" (click)="appliquerPresetPeriode(365)">12 mois</button>
    </div>
  </section>

  <!-- ╔══════ Onglets ══════╗ -->
  <nav class="onglets-nav">
    <button class="onglet" [class.actif]="ongletActif === 'qualite'" (click)="changerOnglet('qualite')">
      <i class="fal fa-shield-check"></i>
      <span>Qualité</span>
      <small>Erreurs · Pertes · Dommages · Réclamations</small>
    </button>
    <button class="onglet" [class.actif]="ongletActif === 'satisfaction'" (click)="changerOnglet('satisfaction')">
      <i class="fal fa-smile"></i>
      <span>Satisfaction</span>
      <small>Note moyenne · Retours clients</small>
    </button>
    <button class="onglet" [class.actif]="ongletActif === 'finance'" (click)="changerOnglet('finance')">
      <i class="fal fa-chart-pie"></i>
      <span>Finance</span>
      <small>Coût · Anomalies · Rentabilité · Encaissements</small>
    </button>
    <button class="onglet" [class.actif]="ongletActif === 'volumes'" (click)="changerOnglet('volumes')">
      <i class="fal fa-chart-bar"></i>
      <span>Volumes &amp; partenaires</span>
      <small>Pics · Évolution · Délais · Partenaires</small>
    </button>
  </nav>

  <!-- ╔══════ Contenu onglet actif ══════╗ -->
  <section class="onglet-contenu">
    <app-rapport-qualite      *ngIf="ongletActif === 'qualite'"      [filtres]="filtres"></app-rapport-qualite>
    <app-rapport-satisfaction *ngIf="ongletActif === 'satisfaction'" [filtres]="filtres"></app-rapport-satisfaction>
    <app-rapport-finance      *ngIf="ongletActif === 'finance'"      [filtres]="filtres"></app-rapport-finance>
    <app-rapport-volumes      *ngIf="ongletActif === 'volumes'"      [filtres]="filtres"></app-rapport-volumes>
  </section>

</div>
